<template>
  <div class="footCss">
    <el-row style="width: 85%;height: 100%;margin: 0 auto;">
      <el-col :span="7" style="padding-top: 20px;margin-left: 15px">
        <el-row class="footBigFont">快速链接</el-row>
        <el-row class="footSmallFont">
          <a class="linkCss" href="http://www.ynu.edu.cn">云南大学</a></el-row>
        <el-row class="footSmallFont">
          <a class="linkCss" href="http://www.gjgxxy.ynu.edu.cn/">
            云南大学国际关系研究院</a></el-row>
      </el-col>
      <el-col :span="9" style="padding-top: 20px;margin-left: 10px">
        <el-row class="footBigFont">联系我们</el-row>
        <el-row class="footSmallFont">地址：云南省昆明市五华区翠湖北路2号云南大学东陆校区国关楼</el-row>
        <el-row class="footSmallFont">ICP备案号：滇ICP备2022005679号</el-row>
      </el-col>
      <el-col :span="7" style="padding-top: 20px;text-align: center">
          <el-row class="footBigFont">微信公众号</el-row>
          <el-row style="margin-top: 10px">
            <el-image style="width: 150px;height: 150px;" :src="require('../assets/qrcode.png')"></el-image>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "myFooter"
}
</script>

<style scoped>
.footCss {
  height: 280px;
  width: 100%;
  background-color: #5866aa;
}

.footSmallFont {
  color: white;
  font-family: "Microsoft YaHei UI Light";
  font-size: 11pt;
  margin-top: 10px;
}

.footBigFont {

  color: white;
  font-family: "Microsoft YaHei UI Light";
  font-size: 14pt;
  margin-top: 10px;
  margin-bottom: 15px;
  font-weight: bold;
}

.linkCss {
  color: white;
  text-decoration: none;
}
</style>
